import { zod } from '@acme/core'
import { z } from 'zod'

import ApiService from '../api.service'

export type Sobreaviso = z.infer<typeof zod.SobreavisoSchema>

export const CreateSobreavisoSchema = z.object({
    data: z
        .string()
        .nonempty('Obrigatório')
        .refine(data => {
            const date = new Date(data)
            return !isNaN(date.getTime())
        }, 'Data inválida'),
    horarioInicial: z
        .string()
        .nonempty('Obrigatório')
        .refine(horarioInicial => {
            const [hora, minuto] = horarioInicial.split(':')
            return hora.length === 2 && minuto.length === 2
        }, 'Horário inválido'),
    horarioFinal: z
        .string()
        .nonempty('Obrigatório')
        .refine(horarioFinal => {
            const [hora, minuto] = horarioFinal.split(':')
            return hora.length === 2 && minuto.length === 2
        }, 'Horário inválido'),
})

export const sobreaviso = new ApiService<Sobreaviso>('sobreavisos')
